export default "__VITE_ASSET__CqdvR97R__"